import { helper } from '@ember/component/helper';

import { qpDateRangeIsPartlyOutsideRange } from 'rise-ui/utils/qp-date.js';

export default helper(function datePartlyUnboundHelper([ start, end, dates ], options) {
  return qpDateRangeIsPartlyOutsideRange({ from: start, to: end }, dates, options)
});
